export type { INavigationLocation } from './core/location';
export type { NavigationURI } from './core/uri';
export type { TParameters, TConstants } from './types';

import { locationN, NavigationLocation, INavigationLocation } from './core/location';
import { uriN, NavigationURI } from './core/uri';

export type ILocationState = INavigationLocation;
export type LocationState = NavigationLocation;
export type UriState = NavigationURI;

export default {
  location: locationN,
  uri: uriN,
  forward: locationN.forward,
  reload: locationN.reload,
  back: locationN.back,
  goTo: locationN.goto
};
